/*  eslint-disable no-console */
import { connect } from 'react-redux'
import React, { PureComponent } from 'react'

import { getDisplayName } from 'util/hoc'
import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import MatrixEnvironment from 'ducks/chat/MatrixEnvironment'
import { ensureUserIsMember } from 'ducks/chat/utils/rooms'
import MatrixUiEnvironment from './MatrixUiEnvironment'

let isOnBeforeFileSendMessageHandlerRegistered = false
let isMemberOfAccountRoom = false
export default function withMatrixClient(WrappedComponent) {
  class WithMatrixClient extends PureComponent {
    static displayName = `WithMatrixClient(${getDisplayName(WrappedComponent)})`

    state = {
      isMatrixReady: false,
    }

    componentDidMount() {
      this.handleComponentDidMount()
      this.registerOnBeforeFileSendMessageHandler()
      this.ensureAccountRoomMember()
    }

    componentDidUpdate() {
      this.registerOnBeforeFileSendMessageHandler()
      this.ensureAccountRoomMember()
    }

    componentWillUnmount() {
      this.isUnmounting = true
    }

    async handleComponentDidMount() {
      if (this.isUnmounting) return
      this.mxEnvironment = MatrixEnvironment
      this.client = await MatrixEnvironment.get()
      this.mxUiEnvironment = await MatrixUiEnvironment.get()
      this.setState({
        isMatrixReady: true,
      })
    }

    registerOnBeforeFileSendMessageHandler() {
      const { accountChatRoomId } = this.props
      if (isOnBeforeFileSendMessageHandlerRegistered) return
      if (accountChatRoomId) {
        MatrixUiEnvironment.registerOnBeforeFileSendMessageHandler({
          accountChatRoomId,
        })
        isOnBeforeFileSendMessageHandlerRegistered = true
      }
    }

    ensureAccountRoomMember() {
      const { accountChatRoomId } = this.props
      const { isMatrixReady } = this.state
      if (isMatrixReady && accountChatRoomId && !isMemberOfAccountRoom) {
        const accountRoom = this.client.getRoom(accountChatRoomId)
        ensureUserIsMember(accountRoom)
        isMemberOfAccountRoom = true
      }
    }

    render() {
      const { isMatrixReady } = this.state
      const { platform, config } = this.mxUiEnvironment || {}
      const { skipUnreadyRender, forwardedRef, ...rest } = this.props
      // HOC component requires using prop-spreading when padding down
      // parent props
      /*  eslint-disable react/jsx-props-no-spreading */
      if (!skipUnreadyRender || isMatrixReady) {
        return (
          <WrappedComponent
            isMatrixReady={isMatrixReady}
            platform={isMatrixReady && platform}
            config={config}
            environment={this.mxEnvironment}
            client={this.client}
            {...rest}
            ref={forwardedRef}
          />
        )
      }
      return null
      /*  eslint-enable react/jsx-props-no-spreading */
    }
  }
  const select = state => ({
    accountChatRoomId: selectAccountChatRoomId(state),
  })
  const WithMatrixClientComponent = connect(select)(WithMatrixClient)

  return React.forwardRef((props, ref) => {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return <WithMatrixClientComponent {...props} forwardedRef={ref} />
  })
}
